module.exports = __webpack_public_path__ + "img/stripe.cb1c2b7e.png";